var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleAnglesLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 36.4687C4.51562 38.4219 4.51562 41.5938 6.46875 43.5469L31.4688 68.5469C33.4219 70.5 36.5937 70.5 38.5469 68.5469C40.5 66.5938 40.5 63.4219 38.5469 61.4687L17.0781 40L38.5313 18.5312C40.4844 16.5781 40.4844 13.4062 38.5313 11.4531C36.5781 9.5 33.4062 9.5 31.4531 11.4531L6.45312 36.4531L6.46875 36.4687ZM61.4688 11.4687L36.4688 36.4687C34.5156 38.4219 34.5156 41.5938 36.4688 43.5469L61.4688 68.5469C63.4219 70.5 66.5938 70.5 68.5469 68.5469C70.5 66.5938 70.5 63.4219 68.5469 61.4687L47.0781 40L68.5313 18.5312C70.4844 16.5781 70.4844 13.4062 68.5313 11.4531C66.5781 9.5 63.4062 9.5 61.4531 11.4531L61.4688 11.4687Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAnglesLeft);
export default __webpack_public_path__ + "static/media/double-angles-left.69ce901beeece3a3841d538c8492428f.svg";
export { ForwardRef as ReactComponent };